<template>
  <div>
    <h2>DiscussionSubpage</h2>
  </div>
</template>

<script>
export default {
  name: "DiscussionSubpage",
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
